import { EffectRepository } from '@/modules/effects/domain/EffectRepository'
import { PendingEffectListScreenData } from '../domain/PendingEffectListScreenData'
import { Effect } from '../domain/Effect'
import { EffectFilters } from '../domain/EffectFilters'

export class PendingEffectListComponent {
    effects_repo:EffectRepository
    screenData: PendingEffectListScreenData

    constructor(effects_repo: EffectRepository, screenData: PendingEffectListScreenData) {
        this.effects_repo = effects_repo
        this.screenData = screenData
    }
  
    async mountList(company_id: number, transaction_id=null, filters=null): Promise<void>{        
        this.screenData.setLoading(true)

        let filt = null;
        if (filters) {
            filt = new EffectFilters(
                filters.state.value,
                filters.concept.value,
                filters.effect_type.value,
                filters.date_from.value,
                filters.date_to.value,
                filters.origin.value,
                filters.account.value,
                filters.total_amount.value,
                filters.total_amount_from.value,
                filters.total_amount_to.value
            )
        }

        let effects = await this.effects_repo.get_pending_effects(company_id, transaction_id, filt)
        if (effects.length > 0){
            this.screenData.setShowSelectEffects(true)
        }
        else {
            this.screenData.setShowSelectEffects(false)
        }
        this.screenData.setEffects(effects)
        this.screenData.setLoading(false)
        this.calculateTableHeight()
    }

    getSelectedEffects(): Effect[]{
        let selected_ids = []
        for(let i in this.screenData.selectedEffects){
            selected_ids.push(this.screenData.selectedEffects[i].id)
        }
        return selected_ids
    }

    calculateTableHeight() {        
        let initNumItemsPerPage = Math.min(this.screenData.limit, 10);
        if (this.screenData.effects.length == 0) {
          this.screenData.setTableHeight('20vh');
        }
        else {
          const rowHeight = 42;
          let tableHeight = rowHeight * (Math.min(this.screenData.effects.length, initNumItemsPerPage) + 1);
          if (this.screenData.effects.length < 10 || this.screenData.limit <10) {
            this.screenData.setTableHeight((tableHeight + 100).toString() + 'px')
          } else {
            this.screenData.setTableHeight((tableHeight).toString() + 'px')
          }
        }
    }

    changeLimit(value) {
        this.screenData.setLimit(value)
        this.calculateTableHeight()
    }
}